import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'propertyFilter' })
export class PropertyFilterPipe implements PipeTransform {
    public transform(items: any[], filter: Object) {
        if (!items || !filter) {
            return items;
        }

        let result = items;
        for (const property of Object.getOwnPropertyNames(filter)) {
            result = result.filter(x => x[property] === filter[property]);
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipes/property-filter.pipe.ts